import {
  ADD_TO_BOOKMARK,
  REMOVE_FROM_BOOKMARK,
  CLEAR_BOOKMARK,
} from "../actions/actionTypes";

export default function cartReducer(state, action) {
  let newBookmark = [...state];

  let bookmarked = JSON.parse(window.localStorage.getItem("bookmark"));

  const saveData = (bookmark) => {
    localStorage.setItem("bookmark", JSON.stringify(bookmark));
  };

  switch (action.type) {
    case ADD_TO_BOOKMARK:
      if (newBookmark.length > 9) {
        newBookmark.pop();
        newBookmark.unshift(action.payload);
      } else {
        newBookmark.unshift(action.payload);
      }

      saveData(newBookmark);
      return newBookmark;
    case REMOVE_FROM_BOOKMARK:
      newBookmark = newBookmark.filter((item) => item.id !== action.payload.id);

      saveData(newBookmark);
      return newBookmark;
    case CLEAR_BOOKMARK:
      localStorage.removeItem("bookmark");

      return [];
    default:
      return state;
  }
}
